<template>
  <button
    v-if="isSubmit"
    type="submit"
    :class="addClass + ' nh-btn nh-btn-type-' + type + ' ' + direction"
  >
    <b-spinner
      v-if="loader"
      small
      label="small spinner"
    />
    {{ title }}
    <span
      class="arrow"
      :style="icon ? `background-image: url(${icon})` : ''"
    />
  </button>
  <router-link
    v-else-if="routeLink"
    :to="routeLink"
    :class="addClass + ' nh-btn nh-btn-type-' + type + ' ' + direction"
  >
    <b-spinner
      v-if="loader"
      small
      label="small spinner"
    />
    {{ title }}
    <span
      class="arrow"
      :style="icon ? `background-image: url(${icon})` : ''"
    />
  </router-link>
  <a
    v-else
    :href="link"
    :class="addClass + ' nh-btn nh-btn-type-' + type + ' ' + direction"
    @click="link ? null : $emit('click')"
  >
    <b-spinner
      v-if="loader"
      small
      label="small spinner"
    />
    {{ title }}
    <span
      class="arrow"
      :style="icon ? `background-image: url(${icon})` : ''"
    />
  </a>
</template>

<script>
export default {
  props: {
    addClass: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    routeLink: {
      type: Object,
      default: null
    },
    isSubmit: {
      type: Boolean,
      default: false
    },
    loader: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'A'
    },
    direction: {
      type: String,
      default: 'right'
    }
  }
}
</script>

<style scoped lang="scss">
  a {
    cursor: pointer;
  }
  .nh-btn {
    color: $body-color;
    border: 2px solid;
    border-radius: 0.313rem;
    padding: 0.75rem 2rem;
    padding-bottom: 0.688rem;
    display: inline-block;
    transition: ease-in-out 0.2s;
    min-width: 190px;
    text-align: center;
    font-size: 0.688rem;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
    .arrow {
        background-image: url("/img/arrow-right2.svg");
        background-repeat: no-repeat;
        background-position: center;
        display: block;
        width: 24px;
        height: 24px;
        position: absolute;
        right: 0.5rem;
        top: 50%;
        transform: translateY(-50%);
        transition: 0.2s right;
    }
    &:hover {
        text-decoration: none;
        .arrow {
            right: 0.2rem;
        }
    }
  }

  .nh-btn-type-A {
    border-color: $warning;
    background-color: $warning;
    &:hover {
        color: white !important;
    }
  }

  .nh-btn-type-B {
    border-color: $warning;
    background-color: $warning;
    border-radius: 10px;
    padding: 0.813rem 2rem;
    &:hover {
        color: white !important;
    }
  }

  .nh-btn-type-C {
    border-color: $warning;
    background-color: white;
    color: black;
    &:hover {
      color: white !important;
      background-color: $warning;
      border-color: $warning;
    }
  }

  .nh-btn-type-C-danger {
    border-color: $warning;
    background-color: white;
    color: black;
    &:hover {
      color: white !important;
      background-color: $danger;
      border-color: $danger;
    }
  }

  .nh-btn-type-D {
    border-color: $danger;
    background-color: $danger;
    color: black;
    &:hover {
      color: white !important;
    }
  }

  .spinner-border {
    margin-right: 0.5rem;
  }

  .left {
    .arrow {
      background-image: url("/img/arrow-left2.svg");
      left: 0.5rem;
      transition: 0.2s left;
    }
    &:hover {
      text-decoration: none;
      .arrow {
          left: 0.2rem;
      }
    }
  }
</style>
